// extracted by mini-css-extract-plugin
module.exports = {"output":"Output_output__psdlp","totals":"Output_totals__1ctyD","reset":"Output_reset__1ez1J"};